export const EKYCRetry = "_ekyc-tries";
